var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { Button, BackgroundImage } from '@alife/simple-ui';
import classnames from 'classnames';
var RefundMessageItem = (function (_super) {
    __extends(RefundMessageItem, _super);
    function RefundMessageItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RefundMessageItem.prototype.render = function () {
        var _a = this.props, _b = _a.templateData, templateData = _b === void 0 ? {} : _b, _c = _a.locale, locale = _c === void 0 ? {} : _c, _d = _a.onClick, onClick = _d === void 0 ? function () { } : _d;
        var subOrderIcon = templateData.subOrderIcon, subOrderIcon2 = templateData.subOrderIcon2, subOrderCount = templateData.subOrderCount, orderTotalCount = templateData.orderTotalCount, orderTotalPrice = templateData.orderTotalPrice, subOrderSKU = templateData.subOrderSKU, subOrderTitle = templateData.subOrderTitle, refundOrderDate = templateData.refundOrderDate, refundOrderId = templateData.refundOrderId, refundOrderReason = templateData.refundOrderReason;
        var orderRest = orderTotalCount - subOrderCount;
        return (React.createElement("div", { className: classnames('card-refund', 'message-card', { 'with-others': orderRest > 0 }) },
            React.createElement("div", { className: "card-header" }, locale.returnRequestTitle || 'New Return Request'),
            React.createElement("div", { className: "card-content flex-column" },
                React.createElement("div", { className: "lzd-refund-suborder" },
                    React.createElement(BackgroundImage, { src: subOrderIcon, className: "card-img" }),
                    React.createElement("div", { className: "desc" },
                        React.createElement("div", { className: "lzd-refund-suborder-title text-two-lines" }, subOrderTitle),
                        React.createElement("div", { className: "lzd-refund-suborder-desc" },
                            React.createElement("span", { className: "sku text-overflow" }, subOrderSKU),
                            React.createElement("span", { className: "count text-overflow" },
                                "x",
                                subOrderCount)))),
                React.createElement("div", { className: "lzd-refund-suborder-total" },
                    React.createElement(BackgroundImage, { src: subOrderIcon2 || subOrderIcon, className: "card-img visibility-" + (orderRest ? '' : 'hidden') },
                        React.createElement("div", { className: "mask" },
                            "+",
                            orderTotalCount - subOrderCount)),
                    React.createElement("div", { className: "lzd-suborder-total-desc" },
                        React.createElement("div", { className: "total-count" },
                            locale.totalReturns || 'Total Return',
                            ":",
                            orderTotalCount),
                        React.createElement("div", { className: "total-price text-overflow" }, orderTotalPrice))),
                React.createElement("div", { className: "lzd-refund-order-desc" },
                    React.createElement("div", null,
                        locale.order || 'Order',
                        ": ",
                        refundOrderId),
                    React.createElement("div", null,
                        locale.orderDate || 'Order Date',
                        ": ",
                        refundOrderDate),
                    React.createElement("div", null,
                        locale.returnReason || 'Return Reason',
                        ": ",
                        refundOrderReason))),
            React.createElement("div", { className: "card-footer right" },
                React.createElement(Button, { className: "btn", onClick: function () { return onClick(templateData); } }, locale.view || 'View'))));
    };
    return RefundMessageItem;
}(React.Component));
export default RefundMessageItem;

//# sourceMappingURL=index.js.map
